import axios from "axios"
import {mergeMap} from "rxjs/operators"
import {of, from} from "rxjs"
import {uploadServiceEndpoint} from "@/AppConfig"

const IncomeApi = {
  uploadIncomeDocument: ({apiKey, payload}) => {
    const {token, formData} = payload
    return from(axios.post(`${uploadServiceEndpoint}/uploadRequest/document`,
      formData,
      {params: {token}, headers: {apikey: apiKey}}
    )).pipe(mergeMap(({data}) => of({data})))
  },

  // TODO:
  // Action proper implementation for productDescription once tenant config is configured by Income/Upload
  requestConsent: ({apiKey, payload}) => {
    const {token, identifier} = payload

    // Generate random 18-character string (letters + numbers)
    const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
    const productDescription = Array.from({length: 18}, () =>
      chars[Math.floor(Math.random() * chars.length)]
    ).join('')

    return from(axios.post(`${uploadServiceEndpoint}/uploadRequest/requestConsent`,
      {token, identifier, productDescription},
      {headers: {apikey: apiKey}}
    )).pipe(mergeMap(({data}) => of({data})))
  },
  consentStatus: ({apiKey, payload}) => {
    const {token} = payload
    return from(axios.post(`${uploadServiceEndpoint}/uploadRequest/consentStatus`,
      {token},
      {headers: {apikey: apiKey}}
    )).pipe(mergeMap(({data}) => of({data})))
  },
  consentedAccounts: ({apiKey, payload}) => {
    const {token} = payload
    return from(axios.post(`${uploadServiceEndpoint}/uploadRequest/consentedAccounts`,
      {token},
      {headers: {apikey: apiKey}}
    )).pipe(mergeMap(({data}) => of({data})))
  },
  selectAccount: ({apiKey, payload}) => {
    const {token, accountId} = payload
    return from(axios.post(`${uploadServiceEndpoint}/uploadRequest/selectAccount`,
      {token, accountId},
      {headers: {apikey: apiKey}}
    )).pipe(mergeMap(({data}) => of({data})))
  }
}

export default IncomeApi
